export default "__VITE_ASSET__DVtyTvg$__"